import {
  ManageUserInfosData,
  ManageUsersData,
  PersonalXFromCommunityData,
  PersonalXFromProjectData,
  TableConstructorData,
  TableConstructorDataObject,
  TableDataAdaptee,
  UsersXForYData,
} from 'src/app/interfaces/tables.interfaces';
import { ManageUserInfosTableDataAdaptee } from './manager-user-infos-table-data.adaptee';
import {
  ManageUsersTableDataAdaptee,
  NoManageTableDataAdaptee,
  PersonalUserInvitesFromCommunityTableDataAdaptee,
  PersonalUserInvitesFromProjectTableDataAdaptee,
  PersonalUserRequestsFromCommunityTableDataAdaptee,
  PersonalUserRequestsFromProjectTableDataAdaptee,
  UsersInvitesTableDataAdaptee,
  UsersRequestsTableDataAdaptee,
} from './table-adaptees.index';
import { TableConstructorDataAdapter } from './table-constructor-data.adapter';
import { UserTableCreators } from './table-creator.enum';

export class TableCreatorFactory {
  public static createTableConstructorData(
    type: UserTableCreators,
    data: TableConstructorDataObject,
  ): TableConstructorData {
    return new TableConstructorDataAdapter(
      UserTableCreatorFactory.createTableAdaptee(type, data),
    ).createTableConstructorData();
  }
}

export class UserTableCreatorFactory {
  public static createTableAdaptee(type: UserTableCreators, data: TableConstructorDataObject): TableDataAdaptee {
    switch (type) {
      case UserTableCreators.MANAGE_USERS:
        return this.getManageUsersAdaptee(data as ManageUsersData);

      case UserTableCreators.MANAGE_USER_INFOS:
        return this.getManageUserInfosAdaptee(data as ManageUserInfosData);

      case UserTableCreators.PERSONAL_USER_INVITES_FOR_COMMUNITY:
        return new PersonalUserInvitesFromCommunityTableDataAdaptee(data as PersonalXFromCommunityData);

      case UserTableCreators.PERSONAL_USER_INVITES_FOR_PROJECT:
        return new PersonalUserInvitesFromProjectTableDataAdaptee(data as PersonalXFromProjectData);

      case UserTableCreators.PERSONAL_USER_REQUESTS_FOR_COMMUNITY:
        return new PersonalUserRequestsFromCommunityTableDataAdaptee(data as PersonalXFromCommunityData);

      case UserTableCreators.PERSONAL_USER_REQUESTS_FOR_PROJECT:
        return new PersonalUserRequestsFromProjectTableDataAdaptee(data as PersonalXFromProjectData);

      case UserTableCreators.ENTITY_USERS_INVITES:
        return new UsersInvitesTableDataAdaptee(data as UsersXForYData);

      case UserTableCreators.ENTITY_USERS_REQUESTS:
        return new UsersRequestsTableDataAdaptee(data as UsersXForYData);

      default:
        throw new Error('Unexpected table type');
    }
  }

  private static getManageUsersAdaptee(data: ManageUsersData): TableDataAdaptee {
    return data.entity.permissions.remove_member
      ? new ManageUsersTableDataAdaptee(data)
      : new NoManageTableDataAdaptee(data);
  }

  private static getManageUserInfosAdaptee(data: ManageUserInfosData): TableDataAdaptee {
    return new ManageUserInfosTableDataAdaptee(data);
  }
}
